import { Category, HourMinute } from "../interfaces";

export const workCategories: Category[] = [
  {
    name: "catalog",
    value: "catalog",
    displayName: "Catalog",
    barColor: "#6788a1",
    bgColor: "rgba(103, 136, 161, 0.2)",
    textColor: "rgba(103, 136, 161)",
  },
  {
    name: "look_book",
    value: "look book",
    displayName: "Book",
    barColor: "#6eb3e8",
    bgColor: "rgba(110, 179, 232, 0.2)",
    textColor: "rgba(110, 179, 232)",
  },
  {
    name: "campaign",
    value: "campaign",
    displayName: "Campaign",
    barColor: "#7817ea",
    bgColor: "rgba(120, 23, 234, 0.2)",
    textColor: "rgba(120, 23, 234)",
  },
  {
    name: "editorial",
    value: "editorial",
    displayName: "Editorial",
    barColor: "#f7567c",
    bgColor: "rgba(247, 86, 124, 0.2)",
    textColor: "rgba(247, 86, 124)",
  },
  {
    name: "show",
    value: "show",
    displayName: "Show",
    barColor: "#127d52",
    bgColor: "rgba(18, 125, 82, 0.2)",
    textColor: "rgba(18, 125, 82)",
  },
  {
    name: "showroom",
    value: "showroom",
    displayName: "Showroom",
    barColor: "#6dc1a2",
    bgColor: "rgba(109, 193, 162, 0.2)",
    textColor: "rgba(109, 193, 162)",
  },
  {
    name: "digital",
    value: "digital",
    displayName: "Digital",
    barColor: "#c7ea17",
    bgColor: "rgba(199, 234, 23, 0.2)",
    textColor: "rgba(199, 234, 23)",
  },
  {
    name: "tv_commercial",
    value: "tv commercial",
    displayName: "TV commercial",
    barColor: "#f89bff",
    bgColor: "rgba(248, 155, 255, 0.2)",
    textColor: "rgba(248, 155, 255)",
  },

  {
    name: "shooting",
    value: "shooting",
    displayName: "Shooting",
    barColor: "#1fe5b3",
    bgColor: "rgba(31, 229, 179, 0.2)",
    textColor: "rgba(31, 229, 179)",
  },
  {
    name: "fashion_show",
    value: "fashion show",
    displayName: "Fashion show",
    barColor: "#e58f1f",
    bgColor: "rgba(229, 143, 31, 0.2)",
    textColor: "rgba(229, 143, 31)",
  },
  {
    name: "event",
    value: "event",
    displayName: "Event",
    barColor: "#03c450",
    bgColor: "rgba(3, 196, 80, 0.2)",
    textColor: "rgba(3, 196, 80)",
  },
  {
    name: "casting",
    value: "casting",
    displayName: "Casting",
    barColor: "#ffff00",
    bgColor: "rgba(255, 255, 0, 0.2)",
    textColor: "rgba(255, 255, 0)",
  },
];

export const modelMeasures = [
  { name: "height", displayName: "Height" },
  { name: "bust", displayName: "Bust" },
  { name: "waist", displayName: "Waist" },
  { name: "hips", displayName: "Hips" },
  { name: "shoes", displayName: "Shoes" },
  { name: "eyes", displayName: "Eyes" },
  { name: "hair", displayName: "Hair" },
];

export const days_of_the_week = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const month_names = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const hours = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23,
];

export const hours_minutes = () => {
  const finalArray: HourMinute[] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m++) {
      const d = new Date();
      d.setHours(h);
      d.setMinutes(m);
      const hour_minutes: HourMinute = { hour: h, minute: m, date: d };
      if (m === 0 || m % 10 === 0) {
        finalArray.push(hour_minutes);
      }
    }
  }
  return finalArray;
};

export const roundToNearestMinute = (date: Date, minute: number) => {
  const minutes = minute;
  const ms = 1000 * 60 * minutes;

  return new Date(Math.round(date.getTime() / ms) * ms);
};

export const logMsgBgColors = {
  correct: "#62ffb1",
  error: "#f88",
  loading: "orange",
};
